import { render, staticRenderFns } from "./IconYeti.vue?vue&type=template&id=deaf6d06&scoped=true"
import script from "./IconYeti.vue?vue&type=script&lang=js"
export * from "./IconYeti.vue?vue&type=script&lang=js"
import style0 from "./IconYeti.vue?vue&type=style&index=0&id=deaf6d06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deaf6d06",
  null
  
)

export default component.exports